var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDazn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4725",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 613.5 617.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 308.8v308.8h613.5V0H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.2 178v102.8l-13.9 13.9-14 14 14 14 13.9 13.9v205.5H73.3V336.7l13.9-13.9 14-14-14-14-13.9-13.9V75.3h467V178zm-444.3 6.4v86.5l18.9 18.9 19 19-19 19-18.9 18.9v173h421.6v-173l-18.9-18.9-19-19 19-19 18.9-18.9v-173H95.9v86.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.1 166.4l14.7 14.7v70l-14.6 14.6-14.7 14.7h-78.2V151.6h78.2l14.6 14.8zM195 216.1v41.7h45.8l7.5-8.1 7.5-8v-51.3l-7.6-8.1-7.6-8.1H195v41.9zm230.3-.1c14.6 35.2 26.5 64 26.5 64.2s-5.5.3-12.3.3h-12.3l-3.2-7.6-3.2-7.6h-65.4l-3 7.4-3 7.4-12.5.2c-9.9.1-12.5 0-12.2-.7.2-.5 12-29.1 26.3-63.5 14.3-34.5 26.1-63 26.3-63.5.3-.6 2.9-.8 11-.7l10.5.2 26.5 63.9zm-48.3-2.2c-5.9 14.3-11 26.5-11.2 27.2-.4 1.2.9 1.3 22.4 1.3 18.3 0 22.7-.2 22.5-.9-.5-2-22.1-53.6-22.5-53.6-.3 0-5.2 11.8-11.2 26zM270 348.3v11.3l-33.7 41.7-33.5 41.6 33.5.2 33.7.1v22.7h-97.7v-11.6l.1-11.4 33.8-41.4 33.8-41.4-33.9-.2-33.8-.2v-22.6H270zm116.1 34.6l32.1 46 .2-46 .1-45.8h22.7v128.8h-25.8l-28.7-41.7-28.7-41.6-.2 41.7-.1 41.6h-24.1V337.1h20.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDazn);
export default __webpack_public_path__ + "static/media/DAZN.9d2cba0bee86ca1f65191c0b2cfe13c5.svg";
export { ForwardRef as ReactComponent };